import Link from "@components/Link/Link";
import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";
import { useSettings } from "@utilities/context/settings";
import clsx from "clsx";
import { useStudentDetails } from "../../context/studentDetail";
import IconDegree from "../../public/image/svg/degree.svg";
import IconGlobal from "../../public/image/svg/global.svg";
import IconProfile from "../../public/image/svg/profile.svg";
import IconScholarship from "../../public/image/svg/scholarship.svg";

import styles from "./C52.2_StudentDetails.module.scss";

const StudentDetails = () => {
  const {
    profileFirstname,
    profileIsScholar,
    profileJobPostProgramme,
    profileJobPreProgramme,
    profileNationality,
    profilePhd,
    profileProgramme,
    profileSurname,
    profileText,
    profileTextTinyMce,
    scholarshipTitle,
  } = useStudentDetails();
  const { programmeRoute, siteSettings } = useSettings();

  return (
    <div className="wrapper">
      <div className={clsx("component", styles["student-details"])}>
        <h1>
          {profileFirstname} {profileSurname}
        </h1>
        <div className={styles["rich-text"]}>
          <ul className={styles["alumni-list-details"]}>
            {(!!profileProgramme || !!profilePhd) && (
              <li className={styles["programme"]}>
                <i className={styles["icon-degree"]}>
                  <IconDegree />
                </i>
                <strong>Programme: </strong>{" "}
                {profileProgramme ? (
                  <Link
                    href={programmeRoute(
                      profileProgramme.type,
                      profileProgramme.slug
                    )}
                  >
                    {profileProgramme.programmeTitle}
                  </Link>
                ) : (
                  profilePhd
                )}
              </li>
            )}

            {!!profileNationality && (
              <li className={styles["nationality"]}>
                <i className={styles["icon-global"]}>
                  <IconGlobal />
                </i>
                <strong>Nationality:</strong> {profileNationality}
              </li>
            )}

            {!!scholarshipTitle && profileIsScholar && (
              <li className={styles["scholarship"]}>
                <i>
                  <IconScholarship />
                </i>
                <strong>Scholarship:</strong>{" "}
                {siteSettings?.scholarshipFundingUrl ? (
                  <Link href={siteSettings?.scholarshipFundingUrl}>
                    {scholarshipTitle}
                  </Link>
                ) : (
                  scholarshipTitle
                )}
              </li>
            )}

            {!!profileJobPreProgramme && (
              <li className={styles["job"]}>
                <i className={styles["icon-profile"]}>
                  <IconProfile />
                </i>
                <strong>Job Pre-programme:</strong> {profileJobPreProgramme}
              </li>
            )}

            {!!profileJobPostProgramme && (
              <li className={styles["job"]}>
                <i className={styles["icon-profile"]}>
                  <IconProfile />
                </i>
                <strong>Job Post-programme:</strong> {profileJobPostProgramme}
              </li>
            )}
          </ul>
          <RichTextDisplay
            richText={profileText}
            tinyMceRichText={profileTextTinyMce}
          />
        </div>
      </div>
    </div>
  );
};

export default StudentDetails;
